import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import * as imageUtils from '../../utils/imageUtils';

const ChatToMeConversationItem = ({comment, actions, artist}) => { 
    const getThumbnail = (imageUrl, roleType) => {
        const params = '?width=120&aspectw=1&quality=80&mode=crop';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    };
    return (
        <li>
            <div className="userthumb">
                <Link to={`/${comment.AuthorUsername}`}>
                    <img src={getThumbnail(comment.Thumbnail, comment.AuthorRoleType)} alt={comment.AuthorName} />
                </Link>
            </div>
            <p className="length">{new Date(comment.Date).toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
            <h2>
                <Link to={`/${comment.AuthorUsername}`} className="transition link">{comment.AuthorName}</Link>
            </h2>
            <div className="message">
                <p>{comment.Comment}</p>
            </div>
        </li>
    );
};

ChatToMeConversationItem.propTypes = {
    comment: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    artist: PropTypes.object.isRequired
};

export default ChatToMeConversationItem;